import { z } from 'zod/v3';
import { isValidTimezone } from '$lib/utils/timezoneList';

/**
 * Front-end write-boundary validation for the timezone preference. Mirrors the
 * backend `UserUpdate` IANA validator so bad input is rejected before the PATCH
 * is ever sent.
 */
export const timezoneSchema = z
	.string()
	.refine(isValidTimezone, { message: 'Must be a valid IANA timezone' });

export type TimezoneValue = z.infer<typeof timezoneSchema>;
